<script lang="ts">
  interface Props {
    css?: string;
  }

  let { css = '' }: Props = $props();
</script>

<svg class="{css}" width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.82042 10.0198L9.03042 13.2298L10.9904 15.1998C11.8204 16.0298 13.1704 16.0298 14.0004 15.1998L19.1804 10.0198C19.8604 9.33977 19.3704 8.17977 18.4204 8.17977L12.8104 8.17977L6.58042 8.17977C5.62042 8.17976 5.14042 9.33977 5.82042 10.0198Z" fill="white"/>
</svg>
